import { render, staticRenderFns } from "./OverlayBreakpoint.vue?vue&type=template&id=21608754&scoped=true&"
var script = {}
import style0 from "./OverlayBreakpoint.vue?vue&type=style&index=0&id=21608754&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21608754",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VOverlay})
